import { get } from 'lodash';
import COLORS from 'constants/colors';
import { applicationTypes, applicationProperties } from 'constants/scripts';
import {
  NUM_SEED_RATE_BINS,
  ADVANCED_SEED_BIN_ROUNDING_VALUE,
  SEED_BIN_ROUNDING_VALUE
} from 'constants/data-viz';
import {
  getProductRateColorFromBins
} from 'util/formatters/data-viz/product';
import {
  isAdvancedScript as isAdvancedScriptFunc,
  getCropForScript
} from 'scripts/selectors';
import {
  getSeedApplicationsForZones,
  getZonesWithSeedRateInRange
} from 'scripts/zones/planting-selectors';
import {
  getAxisBins,
  getAxisBounds
} from 'util/formatters/data-viz/axis';
import { convertForLocaleScalar } from 'util/unitConversion';
import { getApplicationProperty } from 'util/applications';

export const getSeedRateBinsForScript = (script, productValidationValues) => {
  const { zones } = script;
  const isAdvancedScript = isAdvancedScriptFunc(script);
  const crop = getCropForScript(script);
  const seedApplications = getSeedApplicationsForZones(zones);

  const seedRates = seedApplications.map((application) => {
    const rate = getApplicationProperty(application, applicationProperties.RATE);
    // we converted the user's input so we need to convert it back
    return rate ? convertForLocaleScalar({
      quantity: Math.ceil(rate.q),
      unit: rate.u,
      unitType: 'seed-density'
    }) : 0;
  });
  const bounds = getAxisBounds({
    range: seedRates,
    defaultRange: get(productValidationValues, `PLANTING.${crop.toUpperCase()}.RATE`)
  });
  return getAxisBins({
    axisBounds: bounds,
    binRoundingValue: isAdvancedScript ? ADVANCED_SEED_BIN_ROUNDING_VALUE : SEED_BIN_ROUNDING_VALUE,
    numBins: NUM_SEED_RATE_BINS
  });
};

export const getSeedRateLegendForScript = ({ script, productValidationValues }) => {
  if (!script) {
    return {};
  }

  return {
    bins: getSeedRateBinsForScript(script, productValidationValues)
  };
};

export const getSeedRateForAreaChartData = (script, productValidationValues) => {
  const { zones } = script;
  const seedRateBins = getSeedRateBinsForScript(script, productValidationValues);

  // area per rate bin
  const areaValues = [];
  seedRateBins.map((bin, index) => {
    const zonesInBin = getZonesWithSeedRateInRange({ zones, range: bin });
    areaValues[index] = zonesInBin.reduce((total, zone) => {
      return total + zone.meta.area.q;
    }, 0);
  });

  return { areaValues, seedRateBins };
};

export const getSeedRateColorFromBins = ({ bins, rate }) => {
  return getProductRateColorFromBins({ bins, colors: COLORS.rate[applicationTypes.SEED], rate});
};
